import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ObservedValueOf } from 'rxjs/internal/types';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AffiliateGridItem } from 'anchor-shared/lib/model/entity/affiliate';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { sortCaseInsensitive } from '../../../../core/pure-functions/grids/grid-sorting-helper';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { AffiliateDAO } from '../../../../core/services/dao/affiliateDAO';
import { ListGridComponent } from '../../../shared/listGrid/listGrid.component';

@Component({
  selector: 'app-affiliate-grid',
  templateUrl: './affiliate-grid.component.html',
  styleUrls: ['./affiliate-grid.component.scss'],
})
export class AffiliateGridComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  templateData$: Observable<{
    customers: ObservedValueOf<Observable<AffiliateGridItem[]>>;
  }>;
  subs: Subscription[] = [];

  columnDefs: any[];
  rowData: any[];
  editPath = 'manage/admin/user/edit';

  @ViewChild(ListGridComponent)
  grid: ListGridComponent;

  constructor(private affiliateDAO: AffiliateDAO) {}

  ngOnInit() {
    this.initAsyncData();
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  private createColumnDefs() {
    return [
      {
        headerName: 'Email',
        field: 'email',
        filter: 'text',
        minWidth: 50,
        comparator: sortCaseInsensitive,
      },
      {
        headerName: 'First Name',
        field: 'firstName',
        filter: 'text',
        comparator: sortCaseInsensitive,
      },
      {
        headerName: 'Last Name',
        field: 'lastName',
        filter: 'text',
        comparator: sortCaseInsensitive,
      },
      {
        headerName: 'Phone Number',
        field: 'phoneNumber',
        filter: 'text',
        comparator: sortCaseInsensitive,
      },
    ];
  }

  private initAsyncData(): void {
    this.templateData$ = this.affiliateDAO.adminGrid().pipe(
      map((customers) => {
        this.rowData = customers;
        this.columnDefs = this.createColumnDefs();
        return { customers };
      }),
    );
  }
}
